import { ChangeDetectionStrategy, Component, OnInit, ViewChild, inject } from '@angular/core';
import { AbstractContentComponent } from '../abstract-content.component';
import { Context } from '@service/context.service';
import { TABLE_SERVICE } from '@shared/table/table-service';
import { Column } from '@shared/table/column';
import { PublicHolidayTableService } from './public-holiday-table.service';
import { TableComponent } from '@shared/table/table.component';
import { PublicHoliday } from '@entity/public-holiday';
import { MainDataService } from '@service/main-data.service';
import { ToolbarButtonDirective } from '../shared/table/toolbar-button.directive';

@Component({
  selector: 'app-public-holidays',
  templateUrl: './public-holidays.component.html',
  styleUrls: ['./public-holidays.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: TABLE_SERVICE,
      useClass: PublicHolidayTableService,
    },
  ],
  imports: [TableComponent, ToolbarButtonDirective],
})
export class PublicHolidaysComponent extends AbstractContentComponent implements OnInit {
  private mainDataService = inject(MainDataService);

  holidays: PublicHoliday[] = [];
  columns: Column[] = [];
  focusYearRangeStart = new Date().getFullYear() - 2;
  focusYear = new Date().getFullYear();
  @ViewChild(TableComponent) table?: TableComponent;
  private dateColumn?: Column;

  constructor() {
    super(Context.Global, 'MENU.HOLIDAYS');
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initColumns();
  }

  initColumns(): void {
    this.dateColumn = {
      field: 'date',
      headerKey: 'GLOBAL.DATE',
      filterType: 'date',
      width: '200px',
      editable: true,
      minDate: new Date(this.focusYear, 0, 1),
      maxDate: new Date(this.focusYear, 11, 31),
    };
    this.columns = [
      {
        field: 'name.De',
        headerKey: 'GLOBAL.NAME_De',
        minWidth: '200px',
        editable: true,
      },
      {
        field: 'name.Fr',
        headerKey: 'GLOBAL.NAME_Fr',
        minWidth: '200px',
        editable: true,
      },
      {
        field: 'name.It',
        headerKey: 'GLOBAL.NAME_It',
        minWidth: '200px',
        editable: true,
      },
      this.dateColumn,
    ];
    PublicHolidayTableService.cantons.forEach((c) => {
      this.columns.push({
        field: 'activatedCantons.' + c,
        header: c,
        width: '80px',
        filterType: 'boolean',
        editable: true,
        fastEdit: true,
      });
    });
  }

  focusYearChanged(table: TableComponent): void {
    setTimeout(() => {
      if (this.dateColumn) {
        this.dateColumn.minDate = new Date(this.focusYear, 0, 1);
        this.dateColumn.maxDate = new Date(this.focusYear, 11, 31);
      }
      table.loadData();
    }, 250);
  }

  addLastYearsPublicHoliday(): void {
    this.mainDataService.addLastYearsPublicHoliday(this.focusYear).subscribe(() => {
      this?.table?.loadData();
    });
  }
}
